"use client";
import { ActionCard } from "@/components/ActionCard";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

export function SeeDetailedReportCard() {
  const header = (
    <div className="mb-3 w-full aspect-[16/9] rounded-lg border border-border/60 bg-muted/10 flex items-start justify-center p-3">
      <div className="flex w-full max-w-md flex-col items-center justify-start gap-2">
        {/* Overall mini donut via recharts */}
        <div className="flex flex-col items-center justify-center w-full max-w-[110px]">
          <div className="relative h-16 w-full">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={[
                    { name: "Score", value: 88, fill: "#10b981" },
                    { name: "Remaining", value: 12, fill: "transparent" },
                  ]}
                  cx="50%"
                  cy="50%"
                  innerRadius={22}
                  outerRadius={28}
                  strokeWidth={0}
                  cornerRadius={8}
                  dataKey="value"
                  startAngle={90}
                  endAngle={-270}
                  animationDuration={800}
                  animationEasing="ease-out"
                >
                  {[
                    { name: "Score", value: 88, fill: "#10b981" },
                    { name: "Remaining", value: 12, fill: "transparent" },
                  ].map((entry, index) => (
                    <Cell key={`overall-cell-${index}`} fill={entry.fill} />
                  ))}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
            <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
              <span className="tabular-nums text-sm font-semibold text-foreground">
                88
              </span>
            </div>
          </div>
          <span className="mt-0.5 text-[11px] text-muted-foreground/80">
            Overall
          </span>
        </div>

        {/* Three mini KPIs in a row */}
        <div className="mt-1 grid grid-cols-3 gap-3 text-[11px] text-muted-foreground/80">
          <div className="flex flex-col items-center justify-center">
            <span className="tabular-nums text-foreground font-medium text-sm">
              89
            </span>
            <span className="mt-0.5 text-muted-foreground/70">Performance</span>
          </div>
          <div className="flex flex-col items-center justify-center">
            <span className="tabular-nums text-foreground font-medium text-sm">
              86
            </span>
            <span className="mt-0.5 text-muted-foreground/70">
              Website Quality
            </span>
          </div>
          <div className="flex flex-col items-center justify-center">
            <span className="tabular-nums text-foreground font-medium text-sm">
              92
            </span>
            <span className="mt-0.5 text-muted-foreground/70">
              Trust & Security
            </span>
          </div>
        </div>

        {/* Minimal inline hint to view full report */}
        <div className="self-end text-[11px] text-muted-foreground/70 hover:text-foreground/80 transition-colors">
          View full report →
        </div>

        {/* Impactful summary list (no box) */}
        <ul className="mt-2 text-[11px] divide-y divide-border/60">
          <li className="flex items-baseline justify-between gap-3 py-1.5 first:pt-0 last:pb-0">
            <span className="tabular-nums font-semibold text-foreground">
              6
            </span>
            <span className="flex-1 text-muted-foreground/80">
              security issues detected (headers, TLS, mixed content)
            </span>
            <span className="tabular-nums text-foreground/80">≈ +12</span>
          </li>
          <li className="flex items-baseline justify-between gap-3 py-1.5 first:pt-0 last:pb-0">
            <span className="tabular-nums font-semibold text-foreground">
              4
            </span>
            <span className="flex-1 text-muted-foreground/80">
              missing metadata (title, description, og:image, lang)
            </span>
            <span className="tabular-nums text-foreground/80">≈ +6</span>
          </li>
          <li className="flex items-baseline justify-between gap-3 py-1.5 first:pt-0 last:pb-0">
            <span className="tabular-nums font-semibold text-foreground">
              3
            </span>
            <span className="flex-1 text-muted-foreground/80">
              performance blockers (render‑blocking JS/CSS)
            </span>
            <span className="tabular-nums text-foreground/80">≈ +5</span>
          </li>
          <li className="flex items-baseline justify-between gap-3 py-1.5 first:pt-0 last:pb-0">
            <span className="tabular-nums font-semibold text-foreground">
              2
            </span>
            <span className="flex-1 text-muted-foreground/80">
              accessibility gaps (contrast, aria‑labels)
            </span>
            <span className="tabular-nums text-foreground/80">≈ +3</span>
          </li>
          <li className="flex items-baseline justify-between gap-3 py-1.5 first:pt-0 last:pb-0">
            <span className="tabular-nums font-semibold text-foreground">
              7
            </span>
            <span className="flex-1 text-muted-foreground/80">
              quality checks failing (broken links, sitemap)
            </span>
            <span className="tabular-nums text-foreground/80">≈ +4</span>
          </li>
        </ul>
      </div>
    </div>
  );

  return (
    <ActionCard
      ariaLabel="See detailed report"
      title="Detailed report"
      subtitle="We create a complete report with all issues and exact fixes to make your website better"
      header={header}
    />
  );
}
